var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndergroundBgMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 375,
    height: 236,
    viewBox: "0 0 375 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3001_33134)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 236,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.347656,
    y: -576,
    width: 375,
    height: 812,
    fill: "url(#paint0_linear_3001_33134)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-139.197 120.81V103.035C-139.197 10.5285 -66.3596 -65.4405 25.7238 -69.5968L33.613 -77.6641C-66.1312 -77.6641 -147.083 3.18358 -147.083 103.032V120.806H-139.194L-139.197 120.81Z",
    fill: "#BEAEAE",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-39.1638 120.81V103.035C-39.1638 10.5318 33.6703 -65.4405 125.757 -69.5968L133.646 -77.6641C33.9022 -77.6641 -47.0497 3.18358 -47.0497 103.032V120.806H-39.1605L-39.1638 120.81Z",
    fill: "#BEAEAE",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8705 120.81V103.035C60.8705 10.5352 133.701 -65.4405 225.791 -69.5968L233.681 -77.6641C133.937 -77.6641 52.9847 3.18358 52.9847 103.032V120.806H60.8739L60.8705 120.81Z",
    fill: "#BEAEAE",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.902 120.81V103.035C160.902 10.5386 233.729 -65.4405 325.823 -69.5968L333.712 -77.6641C233.968 -77.6641 153.016 3.18358 153.016 103.032V120.806H160.905L160.902 120.81Z",
    fill: "#BEAEAE",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.943 120.81V103.035C260.943 10.5419 333.767 -65.4405 425.864 -69.5968L433.753 -77.6641C334.009 -77.6641 253.057 3.18358 253.057 103.032V120.806H260.947L260.943 120.81Z",
    fill: "#BEAEAE",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.976 120.81V103.035C360.976 10.5453 433.796 -65.4405 525.896 -69.5968L533.786 -77.6641C434.042 -77.6641 353.09 3.18358 353.09 103.032V120.806H360.979L360.976 120.81Z",
    fill: "#BEAEAE",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.835 118.309H-267.632V121.124H633.835V118.309Z",
    fill: "#BEAEAE",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.401 176.996H-369.082V186.532H740.401V176.996Z",
    fill: "#B3B0A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-368.793 229.94H735.448V238.897H-368.793V229.94Z",
    fill: "#B3B0A1",
    stroke: "black",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.615 181.35H-369.082V184.505H746.615V181.35Z",
    fill: "#F7F6F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-368.793 227.887H735.448V230.464H-368.793V227.887Z",
    fill: "#F7F6F1",
    stroke: "black",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.786 194.871H-369.082V221.308H742.786V194.871Z",
    fill: "#B3E0D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-368.793 146.008H735.448V169.566H-368.793V146.008Z",
    fill: "#C49B9B",
    stroke: "black",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-368.793 104.211H735.448V155.474H-368.793V104.211Z",
    fill: "#B2A3A3",
    stroke: "black",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-368.792 103.881H735.449V155.144H-368.792V103.881Z",
    fill: "#B2A3A3",
    stroke: "black",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3001_33134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.21 174.459H951.712V181.47H371.21V174.459Z",
    fill: "#958A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.647 102.73H396.28V102.733C388.695 102.733 372.435 135.025 370.415 168.124C370.4 168.249 370.386 168.373 370.371 168.498C370.364 169.085 370.377 169.665 370.407 170.232C370.515 174.666 371.106 178.311 371.106 178.311H409.647V178.239H951.984V102.863H411.841C411.125 102.863 410.392 102.934 409.647 103.073V102.73Z",
    fill: "white",
    stroke: "#9A9797",
    strokeWidth: 0.0280436,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M498.576 173.626L368.788 173.477C368.094 175.533 369.365 181.72 369.365 181.72H498.621V181.719H951.852V173.625H498.576V173.626Z",
    fill: "#B1CEDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.788 173.477L368.515 173.384L368.581 173.187L368.789 173.187L368.788 173.477ZM498.576 173.626H498.865V173.916L498.575 173.915L498.576 173.626ZM369.365 181.72V182.01H369.129L369.081 181.779L369.365 181.72ZM498.621 181.72H498.91V182.01H498.621V181.72ZM498.621 181.719H498.332V181.43H498.621V181.719ZM951.852 181.719H952.141V182.008H951.852V181.719ZM951.852 173.625V173.336H952.141V173.625H951.852ZM498.576 173.625H498.286V173.336H498.576V173.625ZM368.789 173.187L498.576 173.337L498.575 173.915L368.788 173.766L368.789 173.187ZM369.365 181.72C369.081 181.779 369.081 181.779 369.081 181.778C369.081 181.778 369.081 181.778 369.081 181.778C369.081 181.778 369.081 181.778 369.081 181.777C369.081 181.776 369.081 181.775 369.08 181.774C369.08 181.771 369.079 181.766 369.078 181.76C369.075 181.748 369.072 181.73 369.067 181.707C369.058 181.661 369.044 181.593 369.027 181.505C368.994 181.331 368.947 181.08 368.892 180.772C368.783 180.157 368.645 179.314 368.529 178.407C368.413 177.5 368.318 176.523 368.296 175.64C368.275 174.766 368.323 173.95 368.515 173.384L369.062 173.569C368.906 174.032 368.853 174.76 368.874 175.625C368.896 176.481 368.988 177.436 369.103 178.333C369.218 179.229 369.354 180.062 369.462 180.671C369.515 180.976 369.562 181.224 369.595 181.396C369.612 181.482 369.625 181.549 369.634 181.594C369.639 181.616 369.642 181.634 369.644 181.645C369.646 181.651 369.646 181.655 369.647 181.658C369.647 181.66 369.648 181.661 369.648 181.661C369.648 181.662 369.648 181.662 369.648 181.662C369.648 181.662 369.648 181.662 369.648 181.662C369.648 181.662 369.648 181.662 369.365 181.72ZM498.621 182.01H369.365V181.431H498.621V182.01ZM498.91 181.719V181.72H498.332V181.719H498.91ZM951.852 182.008H498.621V181.43H951.852V182.008ZM952.141 173.625V181.719H951.562V173.625H952.141ZM498.576 173.336H951.852V173.914H498.576V173.336ZM498.286 173.626V173.625H498.865V173.626H498.286Z",
    fill: "#232222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951.712 104.598V101.441L406.412 101.087C406.412 101.087 399.282 100.933 393.589 102.77C381.517 108.191 367.06 156.919 367.06 171.457C367.06 173.999 369.159 173.862 370.666 173.862H951.984V170.673H372.477C374.463 157.2 388.853 105.596 398.819 105.596L951.712 104.598Z",
    fill: "#F8C8C4",
    stroke: "#9A9797",
    strokeWidth: 0.494328,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3001_33134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.48523 224.521H-576.017V231.532H4.48523V224.521Z",
    fill: "#958A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-33.9517 152.793H-20.5848V152.795C-12.9991 152.795 3.26048 185.087 5.28039 218.187C5.29529 218.311 5.30996 218.436 5.32432 218.56C5.33144 219.148 5.31816 219.728 5.28908 220.295C5.18022 224.728 4.59001 228.373 4.59001 228.373H-33.9517V228.301H-576.289V152.925H-36.1457C-35.4289 152.925 -34.6967 152.996 -33.9517 153.136V152.793Z",
    fill: "white",
    stroke: "#9A9797",
    strokeWidth: 0.0280436,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-122.881 223.689L6.90654 223.539C7.60124 225.596 6.33037 231.783 6.33037 231.783H-122.926V231.782H-576.157V223.687H-122.881V223.689Z",
    fill: "#B1CEDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.90654 223.539L7.18047 223.447L7.11398 223.25L6.90621 223.25L6.90654 223.539ZM-122.881 223.689H-123.17V223.978L-122.88 223.978L-122.881 223.689ZM6.33037 231.783V232.072H6.56615L6.61359 231.841L6.33037 231.783ZM-122.926 231.783H-123.215V232.072H-122.926V231.783ZM-122.926 231.782H-122.637V231.492H-122.926V231.782ZM-576.157 231.782H-576.446V232.071H-576.157V231.782ZM-576.157 223.687V223.398H-576.446V223.687H-576.157ZM-122.881 223.687H-122.591V223.398H-122.881V223.687ZM6.90621 223.25L-122.881 223.4L-122.88 223.978L6.90687 223.828L6.90621 223.25ZM6.33037 231.783C6.61359 231.841 6.6136 231.841 6.61361 231.841C6.61362 231.841 6.61364 231.841 6.61366 231.841C6.61371 231.84 6.61377 231.84 6.61386 231.84C6.61402 231.839 6.61427 231.838 6.61459 231.836C6.61522 231.833 6.61615 231.829 6.61737 231.822C6.61981 231.81 6.62339 231.793 6.62802 231.769C6.63727 231.723 6.6507 231.655 6.66752 231.568C6.70116 231.393 6.74836 231.142 6.8028 230.834C6.91162 230.219 7.04957 229.377 7.16576 228.469C7.28184 227.562 7.37684 226.585 7.39864 225.702C7.42019 224.828 7.37155 224.012 7.18047 223.447L6.63261 223.632C6.78889 224.094 6.84189 224.823 6.82055 225.688C6.79943 226.543 6.70698 227.499 6.59217 228.396C6.47749 229.292 6.34113 230.125 6.23338 230.734C6.17952 231.038 6.13287 231.286 6.09972 231.458C6.08314 231.544 6.06995 231.611 6.06092 231.656C6.05641 231.679 6.05294 231.696 6.05061 231.708C6.04945 231.713 6.04857 231.718 6.04799 231.721C6.0477 231.722 6.04748 231.723 6.04734 231.724C6.04727 231.724 6.04722 231.724 6.04719 231.725C6.04717 231.725 6.04716 231.725 6.04715 231.725C6.04715 231.725 6.04715 231.725 6.33037 231.783ZM-122.926 232.072H6.33037V231.494H-122.926V232.072ZM-123.215 231.782V231.783H-122.637V231.782H-123.215ZM-576.157 232.071H-122.926V231.492H-576.157V232.071ZM-576.446 223.687V231.782H-575.867V223.687H-576.446ZM-122.881 223.398H-576.157V223.977H-122.881V223.398ZM-122.591 223.689V223.687H-123.17V223.689H-122.591Z",
    fill: "#232222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-576.016 154.658V151.501L-30.7167 151.148C-30.7167 151.148 -23.5862 150.993 -17.893 152.831C-5.82146 158.251 8.63605 206.979 8.63605 221.518C8.63605 224.06 6.53673 223.922 5.02955 223.922H-576.289V220.734H3.21885C1.23269 207.26 -13.1574 155.656 -23.1229 155.656L-576.016 154.658Z",
    fill: "#F8C8C4",
    stroke: "#9A9797",
    strokeWidth: 0.494328,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M-386.966 240.999V-6.68917L727.995 -7.06445V240.999H-386.966Z",
    fill: "url(#paint1_linear_3001_33134)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3001_33134",
    x1: 34.3135,
    y1: -576,
    x2: 291,
    y2: 197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.539469,
    stopColor: "#C0F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7A9B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3001_33134",
    x1: -341.699,
    y1: 22.2485,
    x2: -266.553,
    y2: 426.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7C6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727BBA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3001_33134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 236,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3001_33134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 585.284,
    height: 84.53,
    fill: "white",
    transform: "translate(366.533 97.5078)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3001_33134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 585.284,
    height: 84.53,
    fill: "white",
    transform: "matrix(-1 0 0 1 9.16217 147.572)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndergroundBgMobile);
export default __webpack_public_path__ + "static/media/UndergroundBgMobile.786466b42bd67686383e.svg";
export { ForwardRef as ReactComponent };